import { useMemo, useState } from "react";
import { HideIcon } from "@hightouch/htui";
import type { ResourceAgentConfig } from "src/components/layout/page-sidebar/agent/resource-agent-sidebar/types";
import { useUser } from "src/contexts/user-context";
import { useCanSetFileVisibility } from "src/pages/projects/library/files/use-can-set-file-visibility";

/**
 * Whether the AMP chat the next message starts is private, and the staff toggle that picks it. A private chat's
 * files stay private, so staff can work in a customer's workspace unseen.
 */
export function useNewAmpChatPrivacy(): ResourceAgentConfig["newChat"] {
  const { user } = useUser();
  const canChoose = useCanSetFileVisibility();
  const [override, setOverride] = useState<boolean>();
  // The API makes a guest admin's chats private when the client doesn't say.
  const isPrivate = override ?? user?.is_impersonating === true;
  return useMemo(
    () =>
      canChoose
        ? {
            isPrivate,
            leftActionItems: [
              {
                key: "private",
                label: "Private (HT only)",
                icon: HideIcon,
                toggle: true,
                isChecked: isPrivate,
                hasInlinePill: true,
                onClick: () => setOverride(!isPrivate),
              },
            ],
          }
        : undefined,
    [canChoose, isPrivate],
  );
}
